import * as React from 'react';
export const strawberrySvg = React.forwardRef(function strawberrySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.122 3.998H13.2v5.087h4.923V3.998Z',
      fill: '#D6C530',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.66 27.998a2.73 2.73 0 0 0 2.72-2.74 2.73 2.73 0 0 0-2.72-2.738 2.73 2.73 0 0 0-2.72 2.739 2.73 2.73 0 0 0 2.72 2.739Zm4.535-4.565c1.502 0 2.72-1.197 2.72-2.674 0-1.477-1.218-2.674-2.72-2.674-1.503 0-2.721 1.197-2.721 2.674 0 1.477 1.219 2.674 2.721 2.674Zm-9.005 0a2.664 2.664 0 0 0 2.656-2.674 2.665 2.665 0 0 0-2.656-2.674 2.666 2.666 0 0 0-2.656 2.674 2.665 2.665 0 0 0 2.656 2.674Zm13.41-4.565c1.502 0 2.72-1.197 2.72-2.674 0-1.477-1.218-2.674-2.72-2.674-1.503 0-2.721 1.197-2.721 2.674 0 1.476 1.219 2.674 2.721 2.674Zm-17.88 0c1.503 0 2.721-1.197 2.721-2.674 0-1.477-1.218-2.674-2.72-2.674C5.218 13.52 4 14.717 4 16.194c0 1.476 1.218 2.674 2.72 2.674Zm4.47-4.566c1.467 0 2.656-1.226 2.656-2.74 0-1.512-1.189-2.738-2.656-2.738-1.466 0-2.656 1.226-2.656 2.74 0 1.512 1.19 2.738 2.656 2.738Zm9.005 0a2.73 2.73 0 0 0 2.72-2.74 2.73 2.73 0 0 0-2.72-2.738 2.73 2.73 0 0 0-2.721 2.74 2.73 2.73 0 0 0 2.721 2.738Z',
      fill: '#ED5A31',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.122 13.65H13.2v4.957h4.923V13.65Z',
      fill: '#ED5A31',
    }),
  );
});
strawberrySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var strawberry = {
  category: 'brand',
  colorable: false,
  name: 'strawberry',
  svg: strawberrySvg,
};
